import { isLoadedWithGlammerDomain } from '../location/isLoadedWithGlammerDomain';

import { get, remove, set } from './cookies';

const TogglePreferredClientCookieName = 'toggle_preferred_client';

const cookieOptions = {
  secure: true,
  domain: '.yammer.com',
  path: '/',
};

export type SetOptOutProgressCookie = () => void;
export const setOptOutProgressCookie: SetOptOutProgressCookie = () => {
  const isGlammerDomain = isLoadedWithGlammerDomain();

  if (isGlammerDomain) {
    const cookieExpiry = new Date(Date.now() + 5 * 60 * 1000);
    set(TogglePreferredClientCookieName, 'legacy', {
      ...cookieOptions,
      expires: cookieExpiry,
    });
  }
};

export type RemoveOptInProgressCookie = () => void;
export const removeOptInProgressCookie: RemoveOptInProgressCookie = () => {
  const isGlammerDomain = isLoadedWithGlammerDomain();

  if (isGlammerDomain) {
    remove(TogglePreferredClientCookieName, cookieOptions);
  }
};

export type GetOptInProgressCookie = () => string | undefined;
export const getOptInProgressCookie: GetOptInProgressCookie = () => get(TogglePreferredClientCookieName);
